import React, { useEffect, useRef, useState } from 'react';
import PreviewContentModal from './PreviewContentModal';

const PAGE_WIDTH = 595;
const PAGE_HEIGHT = 842;

const PreviewPagedContent = ({ resumeData }) => {
  const measureRef = useRef(null);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (!measureRef.current) return;
    const timer = setTimeout(() => {
      const height = measureRef.current.scrollHeight;
      setTotalPages(Math.max(1, Math.ceil(height / PAGE_HEIGHT)));
    }, 100);
    return () => clearTimeout(timer);
  }, [resumeData]);

  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: -9999,
          left: -9999,
          width: PAGE_WIDTH,
          height: PAGE_HEIGHT,
          visibility: 'hidden',
        }}
      >
        <div ref={measureRef}>
          <PreviewContentModal resumeData={resumeData} isMeasure={true} />
        </div>
      </div>

      <div className='flex flex-col gap-6 items-center pb-4'>
        {Array.from({ length: totalPages }).map((_, pageIndex) => (
          <div
            key={pageIndex}
            className='w-[595px] h-[842px] bg-grayscale-gray00 relative pdf-page shadow-2'
            style={{ overflow: 'hidden' }}
          >
            <div
              style={{
                transform: `translateY(-${pageIndex * PAGE_HEIGHT}px)`,
                transformOrigin: 'top left',
              }}
              className={pageIndex === 0 ? '' : 'py-6'}
            >
              <PreviewContentModal resumeData={resumeData} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PreviewPagedContent;
